import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

const userManager = new UserManager({
  authority: import.meta.env.VITE_SSO_AUTHORITY,
  client_id: import.meta.env.VITE_COGNITO_CLIENT_ID,
  redirect_uri: window.location.origin + '/callback',
  response_type: 'code',
  scope: 'openid profile email offline_access',
  metadataUrl:`${import.meta.env.VITE_SSO_AUTHORITY}/api/.well-known/openid-configuration`,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
  silent_redirect_uri: window.location.origin + '/silent-renew.html',
  loadUserInfo: false,
});

export default userManager;

// if (typeof window !== 'undefined') {
//   (window as any).userManager = userManager;
// }
